import React from "react";
import SidePanel from "./SidePanel";

class SidePanelContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOrderPopup: false,
      hideInvoiceAddress: true,
      orderErrors: {},
    };
  }

  setMaterial = (data, side) => {
    // console.log(data)
    if (side === "in") {
      this.props.setInnerMaterial(data)
      this.props.updatePrice()
    } else
      this.props.setOuterMaterial(data)
      this.props.updatePrice()
  };

  handleOrderPopup = (show) => {
    let errors = {};
    this.props.generateOrderJSON(errors);
    if (Object.keys(errors).length > 0) {
      this.setState({
        orderErrors: errors
      })
      return;
    }

    if (!show) {
      this.props.clearCustomerFormErrors();
    }

    this.setState({
      showOrderPopup: show,
      hideInvoiceAddress: !show ? true : this.state.hideInvoiceAddress
    });
  };

  toggleHideInvoiceAddress = () => {
    this.setState({
      hideInvoiceAddress: !this.state.hideInvoiceAddress
    });
  };

  render() {
    return (
      <SidePanel
        room={this.props.room}
        validationSizes={this.props.validationSizes}
        designstep={this.props.designstep}
        nextPage={this.props.nextPage}
        prevPage={this.props.prevPage}
        boxDimensions={this.props.boxDimensions}
        setBoxDimensions={this.props.setBoxDimensions}
        activeGrip={this.props.activeGrip}
        slots={this.props.slots}
        closetProps={this.props.closetProps}
        setTexture={this.setTexture}
        modules={this.props.modules}
        materials={this.props.materials}
        features={this.props.features}
        featureTypes={this.props.featureTypes}
        helps={this.props.helps}
        setActiveModule={this.props.setActiveModule}
        setActiveGrip={this.props.setActiveGrip}
        generateOrderJSON={this.props.generateOrderJSON}
        submitOrder={this.props.submitOrder}
        totalPrice={this.props.totalPrice}
        formErrors={this.props.formErrors}
        orderErrors={this.state.orderErrors}
        showOrderPopup={this.state.showOrderPopup}
        handleOrderPopup={this.handleOrderPopup}
        hideInvoiceAddress={this.state.hideInvoiceAddress}
        toggleHideInvoiceAddress={this.toggleHideInvoiceAddress}
        wallColor={this.props.wallColor}
        setWallColor={this.props.setWallColor}
      />
    );
  }
}

export default SidePanelContainer;
